import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import addgainAdv from "./components/addgainAdv";
import { mapActions } from "vuex";
import { gainAdvData, gainAdvDel } from '@/api/auth/onlineUser';
export default {
  name: "gainAdv",
  components: {
    addgainAdv: addgainAdv
  },
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1,
        page_size: 10
      }
    };
  },
  activated: function activated() {
    this.getData(this.searchData.page);
  },
  methods: {
    getData: function getData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return gainAdvData(_this.searchData);

              case 2:
                query = _context.sent;
                _this.tableData = query.data;
                _this.total = query.total;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return gainAdvDel({
                  id: id
                });

              case 2:
                _this2.getData(_this2.searchData.page);

                _this2.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};